// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD6rYLBqlTQhq7hH4YVxUnqnzBj9lGvkIw",
  authDomain: "sabor-na-medida-c6631.firebaseapp.com",
  projectId: "sabor-na-medida-c6631",
  storageBucket: "sabor-na-medida-c6631.firebasestorage.app",
  messagingSenderId: "643231021559",
  appId: "1:643231021559:web:24a436d1efdfcab37e56f2",
  measurementId: "G-RBGG8DTBWG",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, app, db };
